import { useWireValue } from '@forminator/react-wire'
import CustomModal, { ModalBody, ModalHeader } from '../shared/CustomModal'
import ChainFlowchart from './ChainFlowchart'
import * as store from '@store'
import { useMemo } from 'react'

const FlowchartModal = ({ open, modalHandler, chain }) => {
    
    const runsheet = useWireValue(store.currentRunsheet)
    
    const MemoizedChart = useMemo(() => ChainFlowchart, [])
    
    return (
        <CustomModal
            className="max-w-[100vw]"
            open={open}
            modalHandler={modalHandler}
            center>
            <ModalHeader>Chain Flowchart - {runsheet?.name}</ModalHeader>
            <ModalBody className="h-[85vh]">
                {MemoizedChart({ chain })}
            </ModalBody>
        </CustomModal>
    )
}

export default FlowchartModal